<template>
  <div>
    <component
      v-if="tenderFieldcomponent.component"
      :is="tenderFieldcomponent.component"
      key="tenderField-component"
      class="add-automation__card-row"
      :disabled="disabled"
      :operators="operators"
      :value="tenderFieldcomponent.value"
      @update:value="setValue"/>
  </div>
</template>
<script>
import Vue from 'vue'

export default {
  name: 'tenderField',
  methods: {
    setValue(props) {
      this.$emit('update:value', props)
    },
    /**
     * регистрируем вссе компоненты автоматизации
     * что б не прописывать их все руками
     */
    registerComponents(unregister) {
      const requireComponent = require.context('components/automation/conditions/tenderField', false, /\.vue$/)
      requireComponent.keys().forEach(fileName => {
        const componentConfig = requireComponent(fileName)

        const tenderFieldcomponent = 'condition_tenderField_' + fileName
          .split('/')
          .pop()
          .replace(/\.\w+$/, '')

        if (unregister) {
          delete Vue.options.components[tenderFieldcomponent]
        } else {
          Vue.component(tenderFieldcomponent, componentConfig.default || componentConfig)
        }
      })
    },
  },
  computed: {
    tenderFieldcomponent() {
      if (!this.value?.condidionField) {
        return []
      }
      let componentConditionName = 'condition_tenderField_' + this.value?.condidionField
      if (!Vue.component(componentConditionName)) {
        componentConditionName = null
      }
      return {
        component: componentConditionName,
        value: this.value
      }
    },
  },
  created() {
    this.registerComponents()
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
